import { Crawler } from 'types/crawler';
import { isNumber } from 'utils/typeUtils';
import { CrawlerBaseEditPayload } from 'api/crawlerApi';
import { CrawlerRegistrationFormFields } from './crawlerRegistrationFormFields';

/**
 * クローラー基本情報フォーム
 */
export type CrawlerBaseFormFields = Pick<
  CrawlerRegistrationFormFields,
  'id' | 'name' | 'imageName' | 'apiKeyTemplateId'
>;

export const mapCrawlerToFormFields = ({
  id,
  name = '',
  imageName = '',
  apiKeyTemplateId,
}: Partial<Crawler>): CrawlerBaseFormFields => ({
  id: isNumber(id) ? id.toString() : '',
  name,
  imageName,
  apiKeyTemplateId: isNumber(apiKeyTemplateId)
    ? apiKeyTemplateId.toString()
    : '',
});

export const mapFormFieldsToCrawlerBaseEditPayload = ({
  name,
  imageName,
  apiKeyTemplateId,
}: CrawlerBaseFormFields): CrawlerBaseEditPayload => ({
  name,
  imageName,
  apiKeyTemplateId: /^\d+$/.test(apiKeyTemplateId)
    ? parseInt(apiKeyTemplateId, 10)
    : null,
});
